/**
 * Icons ids use it to map with iconid with filename in images/svg used across application.
 */

const iconIds = (() => {
    return {
        AMENITIES: {
            SWIMMING_POOL: 'swimmingPool',
            AIR_CONDITIONING: 'airConditioning',
            HIGH_SPEED_INTERNET: 'highSpeedInternet',
            FREE_BREAKFAST: 'freeBreakfast',
            AIRPORT_TRANSPORTATION: 'freeAirportTransportation',
            FREE_PARKING: 'freeParking',
            KITCHEN_AMENITY: 'kitchenAmenity',
            PETS_ALLOWED: 'petsAllowed',
            GYM: 'gym'
        },
        COMMON: {
            SEND_MAIL: 'sendMail',
            DELETE: 'delete',
            MAP: 'mapRregular',
            LEFTARROW: 'leftArrow',
            SORT_UP: 'sortUp',
            SORT_DOWN: 'sortDown',
            SEARCH: 'search',
            MINUS: 'minus',
            PLUS: 'plus',
            ANGEL_DOWN: 'angelDown',
            CLOSE: 'timesClose',
            ONE_STAR: 'oneStar',
            ONE_START_REGULAR: 'oneStarRegular',
            LOCATION: 'location',
            CALENDER: 'calender',
            USER: 'user',
            FACEBOOK: 'facebook',
            TWITTER: 'twitter',
            INSTAGRAM: 'instagram',
            PINTEREST: 'pinterest',
            ANGEL_RIGHT: 'angelRight',
            HOTEL_NODATA: 'hotelNoData',
            ASIDE_MENUBAR: 'asideMenubar',
            ANGLE_UP: 'angelUp',
            REFRESH: 'refresh',
            REVIEW: 'review',
            CREDIT_CARD: 'creditCard',
            BED: 'bed',
            OPTION_DOWN: "optionDown",
            OPTION_UP: "optionUp",
            GIFT: "gift",
            HOTEL: 'hotel',
            AIR: 'air',
            RAIL: 'rail',
            BUILDING:'building'
        }
    };
})();

export default iconIds;
